export default "__VITE_ASSET__CSo3x6nL__"